import { Injectable } from '@angular/core';
import { IStorage } from '../../core/interfaces/storage.interface';
import { LoggerService } from '../../services/logger.service';

@Injectable({
  providedIn: 'root',
})
export class LocalStorageService implements IStorage {
  constructor(private readonly logger: LoggerService) {}

  setItem(key: string, value: unknown): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      this.logger.error('Failed to save to localStorage', e as Error, { key });
    }
  }

  getItem<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (!item) {
      return null;
    }

    try {
      return JSON.parse(item);
    } catch {
      return null;
    }
  }

  deleteItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
